import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 211  -  除此之外的场合
 */
export default class EventAdChoice extends EventBase {
  /// <summary>
  /// 除此之外的场合的构造函数
  /// </summary>
  public constructor() {
    super()
    this.Parameter = ['']
  }

  /**
   * 事件Id
   */
  public Code = EventID.AdChoice

  get ChoicePos() {
    return this.Parameter?.[0] ?? ''
  }
  set ChoicePos(value) {
    this.Parameter![0] = value.toString()
  }

}
